// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"267ace19","545":"1d307447","551":"a22a53b6","605":"a680a1e4","662":"22689114","766":"d63b09d2"}[chunkId] + ".chunk.js";
};